import { action } from 'mobx';
import { MouseEvent, useCallback, useState } from 'react';
import { useNavigate } from '../../../../../shared/router/useNavigate';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { getIsFullAmendAllowed } from '../../../../domain/booking/stores/utils/getIsFullAmendAllowed';

export function useHandleClickFullAmend(booking: IBooking, url: string) {
	const [isFullAmendUnavailable, setIsFullAmendUnavailable] = useState(false);
	const newBookingStore = useNewBookingStore();
	const isFullAmendAllowed = getIsFullAmendAllowed(booking);
	const navigate = useNavigate();

	const handleClickFullAmend = useCallback(
		action((e: MouseEvent) => {
			e.preventDefault();

			if (!isFullAmendAllowed) {
				setIsFullAmendUnavailable(true);
				return;
			}

			newBookingStore.originalBooking = booking;

			navigate(url);
		}),
		[booking],
	);

	return { handleClickFullAmend, isFullAmendUnavailable };
}
